import GroupIcon from '@material-ui/icons/Group';
import React from 'react';
import StarIcon from '@material-ui/icons/Star';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import DeleteIcon from '@material-ui/icons/Delete';

export const foldersList = [
  { id: 1, name: 'همه باندل ها', slug: 'episodes', icon: <GroupIcon /> },
  { id: 2, name: 'نشان شده‌ها', slug: 'starred', icon: <StarIcon /> },
  { id: 3, name: 'ویرایش شده‌ها', slug: 'edited', icon: <AccessTimeIcon /> },
  { id: 6, name: 'حذف شده‌ها', slug: 'trash', icon: <DeleteIcon /> },
];

export const episode = [
  {
    id: 1457690400,
    name: 'ابری با احتمال بارش باران',
    profile_pic: 'https://via.placeholder.com/150x150',
    date: '۱۴۰۱/۰۳/۱۲',
    season: '1',
    published: true,
    starred: false,
    frequent: false,
    episode_no: '2',
    descirtion: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است',

    labels: [2],
    folder: 'episodes',
  },
  {
    id: 1457690401,
    name: 'خلبان نامرئی',
    profile_pic: 'https://via.placeholder.com/150x150',
    date: '۱۴۰۱/۰۳/۱۲',
    season: '2',
    published: true,
    starred: false,
    frequent: false,
    episode_no: '2',
    descirtion: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است',
    labels: [2, 1],
    folder: 'episodes',
  },
  {
    id: 1457690402,
    name: 'زندگی به سبک اژدهای سرخ',
    profile_pic: 'https://via.placeholder.com/150x150',
    date: '۱۴۰۱/۰۳/۱۲',
    season: '4',
    published: true,
    starred: false,
    frequent: false,
    episode_no: '2',
    descirtion: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است',
    labels: [3],
    folder: 'episodes',
  },
  {
    id: 1457690403,
    name: 'انسان و سمبل‌هایش',
    profile_pic: 'https://via.placeholder.com/150x150',
    date: '۱۴۰۱/۰۳/۱۲',
    season: '1',
    published: false,
    starred: false,
    frequent: false,
    episode_no: '6',
    descirtion: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است',

    labels: [],
    folder: 'episodes',
  },
  {
    id: 1457690404,
    name: 'رویای آمریکایی',
    profile_pic: 'https://via.placeholder.com/150x150',
    date: '۱۴۰۱/۰۳/۱۲',
    season: '1',
    published: true,
    starred: true,
    frequent: false,
    episode_no: '2',
    descirtion: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است',

    labels: [],
    folder: 'episodes',
  },
  {
    id: 1457690405,
    name: 'انقضا',
    profile_pic: 'https://via.placeholder.com/150x150',
    date: '۱۴۰۱/۰۳/۱۲',
    season: '1',
    published: true,
    starred: false,
    frequent: false,
    episode_no: '2',
    descirtion: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است',

    labels: [],
    folder: 'episodes',
  },
];
